/* eslint-disable no-bitwise */
import jwtDecode from 'jwt-decode';

// SECURITY: the backend's HS256 signing key used to be exported from here. It is never needed in a browser -
// jwt-decode reads the payload without any key - but bundling it shipped the server's signing secret to every
// anonymous visitor, who could then forge a superadmin token. Never reintroduce a signing key on the client.
export const JWT_EXPIRES_IN = 3600 * 24 * 2; // 2 days

export const decode = (token: string): any => {
    const decoded: any = jwtDecode(token);
    const currentTime = Date.now() / 1000;

    if (decoded.exp < currentTime) {
        throw new Error('Expired token');
    }

    return decoded;
};
